import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../../helpers/ApiHelper";

export const veloxityDownloadCsv = createAsyncThunk(
    "veloxityDownloadCsv",
    async ({ audienceId, csvDownloadData }, { rejectWithValue }) => {
        try {
            const apiClient = new APIClient();
            const response = await apiClient.post(`/api/v1/management/csv/plan/${audienceId}/download`, csvDownloadData, {
                responseType: 'blob',
                headers: {
                    'Accept': 'application/zip',
                },
            });
            
            const blob = new Blob([response], { type: 'application/zip' });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'csvFile.zip');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return { audienceId, ...csvDownloadData };
        } catch (error) {
            console.error("Error during CSV download:", error);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

export const downloadCsvPlanSlice = createSlice({
    name: "veloxityDownloadCsv",
    initialState: {
        loading: false,
        reportPlanData: {},
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(veloxityDownloadCsv.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(veloxityDownloadCsv.fulfilled, (state, action) => {
            state.loading = false;
            state.reportPlanData = action.payload;
            state.error = null;
        });
        builder.addCase(veloxityDownloadCsv.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            state.reportPlanData = {};
        });
    },
});

export default downloadCsvPlanSlice.reducer;
